import { cookiesList, setCookie, getCookie, clearLoginData } from '@/utils/cookies.js'
import router from '@/router/index.js'
import { resetObj2 } from '@/utils/tools.js'
import request from '@/utils/request.js'
import api from '@/api/index.js'
import { Notification, Message } from 'element-ui'
const user = {
  state: {
        /*
			登录信息
		*/
		userId: '',          // 用户Id
		token: '',           // 用户登录token
		userType: '',         // 用户类型，未知身份 0， 品牌商 1， 生产商 2  直播相关 9
		phone: '',           // 用户手机号 - 用户账号


		/*
			认证状态
		*/
		userIsAuth: '',           // 用户是否认证  y - 已认证  n - 被拒绝  p - 已提交资料待审核  never - 未提交资料
		useAuthRejectReason: '',  // 用户认证失败原因
		payIsAuth: '',            // 用户支付信息是否认证  y/n

		/*
			个人信息
		*/ 
		userInfo: {
			headImage: '' ,   // 用户头像
			companyName: '',  // 用户公司名称
			companyProvince: '', // 省 - id
			companyProvinceStr: '', // 省 - 名称
			companyCity: '', // 市 - id
			companyCityStr: '', // 市 - 名称
			companyDistrict: '', // 区 - id
			companyDistrictStr: '', // 区 - 名称
			factoryAddressStr:'',//地址详情部分
			addressStr: '',     // 公司地址
			companyLicenseNumber:'',
			companyKeyPerson: '', // 业务负责人
			companyKeyPersonPhone: '', // 业务负责人电话
			companyPhone: '', // 公司电话 
			mainTypeLists: [], // 主营品类
			channel: {}, // 销售渠道
			channelStr: '', // 销售渠道 - 字符串
			handleNeedProcessingLink: '', // 加工工艺
			handleSpecialProcess: '', // 特殊工艺
			mainQuantityStr: '', // 主要品质
			canBuyFabricAbility: '',
			staffsNumber: '', // 员工数
			capcity: '', // 产能
			favoriteArea: '', // 意向接单区域
			isHaveMoney: '', // 是否有提供款
			employeeData: {  // 人员
				total: '',
				childrenLists: []
			},
			machineData: {  // 设备
				total:'',
				childrenLists:[]
			},
			picturesTakenInFactories:[],  // 工厂图
			businessLicenseImg:'',//营业执照
			businessLicenseImgId:''//营业执照id
		},

		servicePhone: '',   //客服电话号码   0571-86221010


		/* 暂时未使用 */
        // forcedLogin: false,  // 是否强制登录
        // isLogined: false,	 // 是否登录
        // userName: "",		 // 用户名
		// headPhoto: '',       // 用户头像
		// unreadMsgNum: 0,    // 未读消息个数

		
		
		// factoryGetOrderChooseAddress:{},//生产商意向接单选择的地址对象
		// brandAddInfoChooseAddress:{},//品牌商补充资料选择的地址对象
		// paymentAccountUrl:'', //支付信息验证的地址
  },
  mutations: {
	setUserId(state, userId) {
		state.userId = userId
	},
	setToken(state, token) {
		state.token = token
	},
	setUserType(state, userType) {
		state.userType = userType
	},
	setPhone(state, phone) {
		state.phone = phone
	},
	setUserInfo(state, data) {
		if (data.companyName != undefined) { state.userInfo.companyName = data.companyName }
		if (data.headImage != undefined) { state.userInfo.headImage = data.headImage }
		if (data.addressStr != undefined) { state.userInfo.addressStr = data.addressStr }
		if (data.companyProvince != undefined) { state.userInfo.companyProvince = data.companyProvince }
		if (data.companyProvinceStr != undefined) { state.userInfo.companyProvinceStr = data.companyProvinceStr }
		if (data.companyCity != undefined) { state.userInfo.companyCity = data.companyCity }
		if (data.companyCityStr != undefined) { state.userInfo.companyCityStr = data.companyCityStr }
		if (data.companyDistrict != undefined) { state.userInfo.companyDistrict = data.companyDistrict }
		if (data.companyDistrictStr != undefined) { state.userInfo.companyDistrictStr = data.companyDistrictStr }
		if (data.factoryAddressStr != undefined) { state.userInfo.factoryAddressStr = data.factoryAddressStr }
		if (data.companyLicenseNumber != undefined) { state.userInfo.companyLicenseNumber = data.companyLicenseNumber }
		if (data.companyKeyPerson != undefined) { state.userInfo.companyKeyPerson = data.companyKeyPerson }
		if (data.companyKeyPersonPhone != undefined) { state.userInfo.companyKeyPersonPhone = data.companyKeyPersonPhone }
		if (data.companyPhone != undefined) { state.userInfo.companyPhone = data.companyPhone }
		if (data.mainTypeLists != undefined) { state.userInfo.mainTypeLists = data.mainTypeLists }
		if (data.channel != undefined) { state.userInfo.channel = data.channel }
		if (data.channelStr != undefined) { state.userInfo.channelStr = data.channelStr }
		if (data.handleNeedProcessingLink != undefined) { state.userInfo.handleNeedProcessingLink = data.handleNeedProcessingLink }
		if (data.handleSpecialProcess != undefined) { state.userInfo.handleSpecialProcess = data.handleSpecialProcess }
		if (data.mainQuantityStr != undefined) { state.userInfo.mainQuantityStr = data.mainQuantityStr }
		if (data.canBuyFabricAbility != undefined) { state.userInfo.canBuyFabricAbility = data.canBuyFabricAbility }
		if (data.staffsNumber != undefined) { state.userInfo.staffsNumber = data.staffsNumber }
		if (data.capcity != undefined) { state.userInfo.capcity = data.capcity }
		if (data.favoriteArea != undefined) { state.userInfo.favoriteArea = data.favoriteArea }
		if (data.isHaveMoney != undefined) { state.userInfo.isHaveMoney = data.isHaveMoney }
		if (data.employeeData != undefined) { state.userInfo.employeeData = data.employeeData }
		if (data.machineData != undefined) { state.userInfo.machineData = data.machineData }
		if (data.picturesTakenInFactories != undefined) { state.userInfo.picturesTakenInFactories = data.picturesTakenInFactories }
		if (data.businessLicenseImg != undefined) { state.userInfo.businessLicenseImg = data.businessLicenseImg }
		if (data.businessLicenseImgId != undefined) { state.userInfo.businessLicenseImgId = data.businessLicenseImgId }
	},

	setUserAuth(state, data) {
		if (data.userIsAuth != undefined) {
			state.userIsAuth = data.userIsAuth
		}
		if (data.useAuthRejectReason != undefined) {
			state.useAuthRejectReason = data.useAuthRejectReason
		}
		if (data.payIsAuth != undefined) {
			state.payIsAuth = data.payIsAuth
		}
	},
	// 重置state
	resetUserState(state) {
		resetObj2(state)
	},
	// 设置平台联系电话
	setServicePhone(state, data) {
		state.servicePhone = data
	},
  },
  actions: {
	// 设置登录信息
	setLoginInfo({commit}, data) {
		if (data.token != undefined) {
			commit('setToken', data.token)
			setCookie(cookiesList.token, data.token) 
		}
		if (data.userId != undefined) {
			commit('setUserId', data.userId)
			setCookie(cookiesList.userId, data.userId) 
		}
		if (data.userType != undefined) {
			commit('setUserType', data.userType)
			setCookie(cookiesList.userType, data.userType) 
		}
		if (data.phone != undefined) {
			commit('setPhone', data.phone)
			setCookie(cookiesList.phone, data.phone)
		}
	},
	// 获取本地信息
	getLocalInfo({dispatch, commit}) {
		let token = getCookie(cookiesList.token)
		let userId = getCookie(cookiesList.userId)
		let userType = getCookie(cookiesList.userType)
		let phone = getCookie(cookiesList.phone) 
		commit('setUserId', userId || '')
		commit('setToken', token || '')
		commit('setPhone', phone || '')
		commit('setUserType', userType || '')
		dispatch('getUserInfo')
	},

	// 获取用户认证信息
	getUserAuth({commit, state}) {
		return new Promise((resolve, reject) => {
			request({
				url: api.checkUserAuth,
				data: {
					userId: state.userId
				}
			}).then(res => {
				// console.log(res)
				if (res.errorCode === 200) {
					commit('setUserAuth', {
						userIsAuth: res.data.authResult,
						useAuthRejectReason: res.data.authRejectCausation,
						payIsAuth: res.data.yijipayIsPayAccount
					})
					resolve(res)
				} else if (res.errorCode === -10010) {
					commit('setUserAuth', {
						userIsAuth: 'never',
						useAuthRejectReason: '',
						payIsAuth: ''
					})
					resolve(res)
				} else {
					reject(res)
				}
			}).catch(err => {
				console.log(err)
				reject(err)
			})
		})
	},
	// 获取个人信息
	getUserInfo({commit, state}) {
		return new Promise((resolve, reject) => {
			request({
				url:api.findUserAuthInfo,
				data: {
					userId: state.userId
				}
			}).then(res => {
				// console.log('findUserAuthInfo:res', res)
				if (res.errorCode == 200) {
					let mainTypeLists, // 主营品类
						channel,       // 销售渠道
						channelStr,    // 销售渠道 - 字符串
						staffDevice = {}, // 加工工艺 等信息
						employeeData, // 人员
						machineData // 设备
					if(res.data.regStr) {
						// 主营品类
						mainTypeLists = JSON.parse(res.data.regStr).product || []
						
						// 销售渠道
						channel = JSON.parse(res.data.regStr).channel || {};
						if (channel.list) {
							channel.list.forEach((item,index) => {
								if(item.isSelect == 1) {
									if (index == 0) { 
										channelStr = item.dataName
									} else {
										channelStr = channelStr + '、' + item.dataName;
									}
									
								}
							});
						}
					}		
					if (res.data.staffDevice) {
						staffDevice = JSON.parse(res.data.staffDevice);
					}
					if (res.data.staffInfo) {
						employeeData = JSON.parse(res.data.staffInfo).employeeData || ''
						machineData = JSON.parse(res.data.staffInfo).machineData || ''
					}
					commit('setUserInfo', {
						companyLicenseNumber:res.data.companyLicenseNumber,
						companyName: res.data.companyName,
						headImage: res.data.headImage ? api.imgPrev + res.data.headImage : '',
						addressStr: res.data.addressStr,
						companyProvince: res.data.companyProvince, // 省 - id
						companyProvinceStr: res.data.companyProvinceStr, // 省 - 名称
						companyCity: res.data.companyCity, // 市 - id
						companyCityStr: res.data.companyCityStr, // 市 - 名称
						companyDistrict: res.data.companyDistrict, // 区 - id
						companyDistrictStr: res.data.companyDistrictStr, // 区 - 名称
						factoryAddressStr:res.data.factoryAddressStr,
						companyKeyPerson: res.data.companyKeyPerson,
						companyKeyPersonPhone: res.data.companyKeyPersonPhone,
						companyPhone: res.data.companyPhone,
						mainTypeLists: mainTypeLists, // 主营品类
						channel: channel,  // 销售渠道
						channelStr: channelStr || '',
						handleNeedProcessingLink: staffDevice.handleNeedProcessingLink || '-', //加工工艺
						handleSpecialProcess: staffDevice.handleSpecialProcess || '-', //特殊工艺
						mainQuantityStr: staffDevice.mainQuantityStr || '-', //主要品质
						canBuyFabricAbility: staffDevice.canBuyFabricAbility,
						staffsNumber: staffDevice.staffsNumber, //员工数
						capcity: staffDevice.capcity, //产能
						favoriteArea: staffDevice.favoriteArea, //意向接单区域
						employeeData: employeeData, // 人员
						machineData: machineData, // 设备
						picturesTakenInFactories: res.data.picturesTakenInFactories || [],
						businessLicenseImg:res.data.businessLicenseImg||'',
						businessLicenseImgId:res.data.businessLicenseImgId||'',
					})
				} else {
					Message.error(res.errorMsg || '网络错误')
				}
			}).catch(err => {
				console.log('findUserAuthInfo:err', err)
			})
		})
	},

	// 获取平台联系电话
	setServicePhone({commit}) {
		request({
			url: api.appConfigInfo,  
			data: {
				"configName": "platform_customer_service_telephone"
			}
		}).then(res => {
			// console.log(res)
			if (res.errorCode == 200) {
				commit('setServicePhone', res.data.config_value)
			} 
		})
	},


	// 退出登录
	logOut({commit, state}, type) {  // type - 1 主动退出登录  type - 2 被动退出登录（token失效，错误等） 
		if (type == 1) {
			// 调用 退出登录 接口
			request({
				url: api.userSignOut,
				method: 'post',
				noAuth: true,
				data: {
					token: state.token,
					userId: state.userId
				}
			}).then(res => {
				// console.log(res)
			}).catch(err => {
				console.log(err)
			})
		}
		commit('resetUserState')
		clearLoginData()
		if (type == 1) {
			Notification.info({
				title: '退出登录',
				message: '您已成功退出登录',
				duration: 3000
			})
		}
		router.push('/login')
		
	}
  }
}

export default user
